import { pathOr } from 'ramda';
import { Project } from 'redux/types/account';
import { createSelector } from 'reselect';
import accountSelector from './accountSelector';

export default function accountProjectsSelector(state: any): Project[] {
  return createSelector(accountSelector, pathOr([], ['projects', 'list']))(state);
}
